import { render, staticRenderFns } from "./f-content-restrictions.vue?vue&type=template&id=0d48cd0f&lang=pug&"
import script from "./f-content-restrictions.vue?vue&type=script&lang=js&"
export * from "./f-content-restrictions.vue?vue&type=script&lang=js&"
import style0 from "./f-content-restrictions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d48cd0f')) {
      api.createRecord('0d48cd0f', component.options)
    } else {
      api.reload('0d48cd0f', component.options)
    }
    module.hot.accept("./f-content-restrictions.vue?vue&type=template&id=0d48cd0f&lang=pug&", function () {
      api.rerender('0d48cd0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/fields/f-content-restrictions.vue"
export default component.exports